export const PACKAGE_NAME = 'geolocation-popup';
export const COUNTRY_CODE_COOKIE_NAME = 'country-code';
export const GEOLOCATION_LOCAL_STORAGE_KEY = 'hideGeolocationUntil';
